export default __webpack_public_path__ + "static/aerfa-eb9a203ca9d107c661caaeddd3c2e8da.png";